// PERSONNEL MODAL
$(document).ready(function(){
    $(document).on('click touchend', '.open-featured-story-modal', function(event){
        if (dragging) return;

        event.preventDefault();

        $('body').addClass('loading');

        $storyDiv = $(this).parent().parent().parent();

        Swal.fire({
            animation: false,
            html: $storyDiv.html(),
            showConfirmButton: false,
            showCloseButton: true,
            width: "75rem",
            customClass: {
                container: 'slab stories',
                popup: 'story'
            }
        })

        $('body').removeClass('loading');

        // $ajaxUrl = $(this).attr('href');

        // $.ajax({
		// 	url: $ajaxUrl,
		// 	type: 'GET',
		// 	success: function(data){
        //         $profileData = $(data).find("#main-content").html();

        //         // Display the results
        //         Swal.fire({
        //             animation: false,
        //             html: '<div class="personnel-detail modal"><main>' + $profileData + '</main></div>',
        //             showConfirmButton: false,
        //             showCloseButton: true,
        //             width: "75rem"
        //         })
        //     },
        //     error: function(xhr, status, error) {
        //         Swal.fire({
        //             animation: false,
        //             icon: 'error',
        //             title: 'Oops...',
        //             text: 'There was an error loading theh personnel file. Please try again.'
        //           })

		// 		document.body.classList.remove("loading");
        //     },
		// 	complete: function(data){
        //         $('body').removeClass('loading');
		// 	}
		// });
    });
});